import React, { Component, PropTypes } from "react";
import {
	NitroLoading,
	NitroContentNotAvailable,
	NitroText,
	NitroIcon
} from "nitro-components";

import DriverListItem from "./DriverListItem";

import styled from "styled-components";

const MainContainer = styled.div`
	max-height: 600px;
	overflow-y: scroll;
	
`;
const DriverListContainer = styled.ul`
	padding: 10px 40px;
	margin: 0px;
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;

`;

const NitroIconHolder = styled.section`

	width: 10%;;
`;

const IndexHolder = styled.section`
	text-align: center;
	width: 20%;
`;

const DriverName = styled.section`
	width: 60%;
	overflow: hidden;
`;

class DriverList extends Component {
	constructor(props) {
		super(props);
		this.state = {
			selectedIndex: 0
		};
	}

	displayDetail = (i, item) => {
		this.setState(
			{
				selectedIndex: i
			},
			this.props.onSelectDriver(item)
		);
	};
	render() {
		const { data } = this.props;
		const { selectedIndex } = this.state;
		return (
			<MainContainer>
				<DriverListContainer>
					{data.map((item, i) => (
						<div
							key={item.DriverId}
							onClick={() => this.displayDetail(i, item)}
						>
							<DriverListItem
								data={item}
								index={i}
								selected={i === selectedIndex}
							/>
						</div>
					))}
				</DriverListContainer>
			</MainContainer>
		);
	}
}

DriverList.propTypes = {
	data: PropTypes.array.isRequired,
	onSelectDriver: PropTypes.func,
	error: PropTypes.bool // TODO .isRequired
};

export default DriverList;



// WEBPACK FOOTER //
// ./src/features/insights/components/driverSafety/components/DriverList.js